import { Images } from '@/assets/images';
import { REGEX } from '@/constant';
import { cls, dayjs, formatDate } from '@/utils';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	organization: '',
	representative: '',
	violationDetails: '',
	personalInformation: '',
	penaltyPoints: '',
	cumulativeTotal: '',
	registDate: '',
	headOfDepartment: '',
	organizationRepresentative: '',
	organizationRepresentativeSignature: '',
	registrantAffiliated: '',
	registrantPosition: '',
	registrantName: '',
	registrantPhone: '',
};

type IValues = typeof initializeValue;

export const ORGANIZATION_NOTICE_OF_VIOLATION_CONFIG: FormConfig<IValues> = {
	initializeValue,
	title: '지자체 위반사항 주의서',
	mapPropToValues() {
		return { registDate: formatDate(dayjs()) };
	},
	pages: [
		{
			background: {
				src: Images.formOrganizationNoticeOfViolationHighlight,
				className: 'template',
				dataSource: Images.formOrganizationNoticeOfViolation,
			},
			textAreas: [
				{
					name: 'organization',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[164px] left-[178px] w-[270px]',
					maxLength: 16,
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'representative',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[164px] left-[552px] w-[146px]',
					maxLength: 10,
					regex: REGEX.ALLOW_KR_EN,
				},
				(values, index) => ({
					name: 'violationDetails',
					maxHeight: 92,
					className: 'text-base',
					containerClassName: cls(
						'absolute top-[198px] left-[178px] w-[520px]',
						values?.violationDetails && 'bg-white'
					),
					maxLength: 160,
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'personalInformation',
					maxHeight: 148,
					className: 'text-base',
					containerClassName: cls(
						'absolute top-[295px] left-[178px] w-[520px]',
						values?.violationDetails && 'bg-white'
					),
					maxLength: 240,
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'penaltyPoints',
					maxHeight: 24,
					maxLength: 4,
					className: 'text-[15px]',
					containerClassName: cls(
						'absolute top-[445px] left-[404px] w-[38px]',
						values?.penaltyPoints && 'bg-white'
					),
					regex: REGEX.ALLOW_NUMBER,
				}),
				(values, index) => ({
					name: 'cumulativeTotal',
					maxHeight: 24,
					className: 'text-[15px]',
					containerClassName: cls(
						'absolute top-[471px] left-[362px] w-[45px]',
						values?.cumulativeTotal && 'bg-white'
					),
					maxLength: 4,
					regex: REGEX.ALLOW_NUMBER,
				}),
				(values, index) => ({
					name: 'headOfDepartment',
					maxHeight: 24,
					className: 'text-base text-right',
					containerClassName: cls(
						'absolute top-[780px] left-[82px] w-[205px]',
						values?.headOfDepartment && 'bg-white'
					),
					maxLength: 14,
					regex: REGEX.ALLOW_KR_SPACE,
				}),
				{
					name: 'organizationRepresentative',
					maxHeight: 42,
					className: 'text-base leading-5',
					containerClassName: 'absolute top-[864px] left-[178px] w-[271px]',
					maxLength: 36,
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'registrantAffiliated',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[926px] left-[298px] w-[152px]',
					maxLength: 10,
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'registrantPosition',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[926px] left-[552px] w-[147px]',
					maxLength: 10,
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'registrantName',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[965px] left-[298px] w-[152px]',
					maxLength: 10,
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'registrantPhone',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[965px] left-[552px] w-[147px]',
					maxLength: 14,
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
			],
			datePickers: [
				{
					name: 'registDate',
					segmentedInputs: true,
					style: { fontSize: '16px' },
					format: 'YY   MM   DD',
					containerClassName: 'absolute top-[754px] left-[358px]',
				},
			],
			signatures: [
				{
					name: 'organizationRepresentativeSignature',
					className: 'absolute w-[147px] h-[38px] top-[866px] left-[552px]',
				},
			],
		},
	],
};
